import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLDListElement
  Blocks: {
    default: []
  }
}

export const LessonFields: TOC<Signature> = <template>
  <dl ...attributes>
    {{yield}}
  </dl>
</template>

export default LessonFields
